/** ISO 3166-1 alpha-2 options for vessel flag (harbor compliance). */
export const VESSEL_FLAG_OPTIONS: ReadonlyArray<{ code: string; labelEt: string; labelEn: string }> = [
  { code: 'EE', labelEt: 'Eesti', labelEn: 'Estonia' },
  { code: 'FI', labelEt: 'Soome', labelEn: 'Finland' },
  { code: 'SE', labelEt: 'Rootsi', labelEn: 'Sweden' },
  { code: 'NO', labelEt: 'Norra', labelEn: 'Norway' },
  { code: 'DK', labelEt: 'Taani', labelEn: 'Denmark' },
  { code: 'DE', labelEt: 'Saksamaa', labelEn: 'Germany' },
  { code: 'PL', labelEt: 'Poola', labelEn: 'Poland' },
  { code: 'LV', labelEt: 'Läti', labelEn: 'Latvia' },
  { code: 'LT', labelEt: 'Leedu', labelEn: 'Lithuania' },
  { code: 'RU', labelEt: 'Venemaa', labelEn: 'Russia' },
  { code: 'GB', labelEt: 'Ühendkuningriik', labelEn: 'United Kingdom' },
  { code: 'NL', labelEt: 'Holland', labelEn: 'Netherlands' },
  { code: 'BE', labelEt: 'Belgia', labelEn: 'Belgium' },
  { code: 'FR', labelEt: 'Prantsusmaa', labelEn: 'France' },
  { code: 'ES', labelEt: 'Hispaania', labelEn: 'Spain' },
  { code: 'IT', labelEt: 'Itaalia', labelEn: 'Italy' },
  { code: 'GR', labelEt: 'Kreeka', labelEn: 'Greece' },
  { code: 'HR', labelEt: 'Horvaatia', labelEn: 'Croatia' },
  { code: 'CH', labelEt: 'Šveits', labelEn: 'Switzerland' },
  { code: 'AT', labelEt: 'Austria', labelEn: 'Austria' },
  { code: 'US', labelEt: 'USA', labelEn: 'United States' },
  { code: 'CA', labelEt: 'Kanada', labelEn: 'Canada' },
];
